import React, {useState, useEffect} from 'react';
import styles from './StaffMembersComparisonGraph.module.scss';
import moment from "moment";
import api from "../../helpers/api";

import Loader from "../miscellaneous/Loader/Loader";
import _ from "lodash";
import {ResponsiveBar} from '@nivo/bar'
import DateRangeSelector from "../miscellaneous/DateRangeSelector/DateRangeSelector";
import {$t} from "../../helpers/translator";

function StaffMembersComparisonGraph({id, userType}) {
    const [loading, setLoading] = useState(false);
    const [graphReadyData, setGraphReadyData] = useState([]);

    const [payload, setPayload] = useState({
        clinicId: '',
        sort: 'treatments',
        order: 'desc',
        search: '',
        startDate: moment().subtract(30, 'day').format('YYYY/MM/DD'),
        endDate: moment().format('YYYY/MM/DD'),
        page: 1,
        per_page: 30,
    });


    useEffect(() => {
        getData();
    }, [payload]);


    async function getData() {
        setLoading(true)
        try {
            let res = await api.get(`staff?clinic_id=${payload.clinicId}&sort=${payload.sort}&order=${payload.order}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}&startDate=${payload.startDate}&endDate=${payload.endDate}`);

            if (!res.success) {
                return;
            }

            setDataFormat(res.data.data.data);
        } catch (e) {
            console.error(e)
        }
    }

    function setDataFormat(rawData) {
        // console.log('rawData', rawData)
        let staffData = [];
        _.forEach(rawData, (v, k) => {
            if (v.treatments) {
                staffData.push(v)
            }
        })
        setLoading(false)
        setGraphReadyData(staffData);
    }

    function setDateRange(dates) {
        let newPayload = {...payload};
        newPayload.startDate = dates.startDate;
        newPayload.endDate = dates.endDate;

        setPayload(newPayload)
    }


    function returnGraph() {
        return (
            <ResponsiveBar
                data={graphReadyData}
                keys={[
                    'treatments',
                ]}
                indexBy="staff_name"
                margin={{top: 30, right: 50, bottom: 50, left: 60}}
                padding={0.3}
                valueScale={{type: 'linear'}}
                indexScale={{type: 'band', round: true}}
                colors={[
                    '#E0DAFF',
                ]}

                axisTop={null}
                axisRight={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: $t('global.staff.staffMember'),
                    legendPosition: 'middle',
                    legendOffset: 32
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: $t('global.staff.treatments'),
                    legendPosition: 'middle',
                    legendOffset: -40
                }}
                labelSkipWidth={12}
                labelSkipHeight={12}
                // labelTextColor="#E0DAFF"
                role="application"
                // ariaLabel="Nivo bar chart demo"
                // barAriaLabel={function (e) {
                //     return e.id + ": " + e.formattedValue + " in country: " + e.indexValue
                // }}
            />
        )
    }

    return (
        <>
            <div className="alma-box">
                <div className={`alma-box-header ${styles.headerFlex}`}>
                    <div>
                        <h3>{$t('global.staff.staffTreatments')}</h3>
                    </div>
                    <DateRangeSelector onChange={(data) => {
                        setDateRange(data);
                    }}/>
                </div>
                <div className='container'>
                    <div style={{width: '100%', height: 300, maxHeight: 340}}>
                        {!loading ?
                            <>
                                {graphReadyData && graphReadyData.length ?
                                    returnGraph()
                                    :
                                    <div className={styles.noData}>
                                        <div>
                                            {$t('global.staff.noDataFound')}
                                        </div>
                                    </div>}
                            </>
                            :
                            <Loader/>
                        }
                    </div>
                </div>
            </div>
        </>)
}

export default StaffMembersComparisonGraph;
